/** Wait before the next try: 1 s, then twice as long each time, up to 15 s. */
export function retryDelayMs(attempt: number): number {
  return Math.min(15_000, 1000 * 2 ** Math.max(0, attempt));
}
